<script>
  import {numUtil} from '@/helper/num';
  import Select from './Select.svelte';
  import lang from './DatepickerFormItem.lang';

  export let LG;
  export let value = '';

  const yearOptions = createYearOptions();

  let hasInit = false;
  let dayOptions;
  let monthOptions;
  let year = '';
  let month = '';
  let day = '';

  $: updateDayOptions(year, month);
  $: createMonthOptions(year);
  $: updateValue(year, month, day);
  $: parseValue(value);

  function parseValue(value) {
    if (hasInit) {
      return;
    }
    if (value) {
      hasInit = true;
      const inputValue = value.split('-');
      year = inputValue[0];
      month = inputValue[1];
      day = inputValue[2];
      createMonthOptions(year);
      updateDayOptions(year, month);
    }
  }

  function updateValue(y, m, d) {
    if (dayOptions.filter((obj) => obj.value === d).length === 0) {
      day = '';
      d = '';
    }
    if (monthOptions.filter((obj) => obj.value === m).length === 0) {
      month = '';
      day = '';
      m = '';
      d = '';
    }
    value = y && m && d ? [y, m, d].join('-') : '';
  }

  function createYearOptions() {
    const now = new Date();
    const result = [];
    const currentYear = now.getFullYear();
    for (let i = currentYear - 18; i >= 1900; i--) {
      const value = String(i);
      result.push({text: value, value});
    }
    return result;
  }

  function createMonthOptions(year) {
    const result = [];
    for (let i = 1; i < 13; i++) {
      const maxYear = yearOptions[0].value;
      if ((year === maxYear && i <= new Date().getMonth() + 1) || year !== maxYear) {
        const value = numUtil.pad(i);
        result.push({text: value, value});
      }
    }
    monthOptions = result;
  }

  function updateDayOptions(year, month) {
    const maxYear = yearOptions[0].value;
    const today = new Date();
    const thisMonth = numUtil.pad(today.getMonth() + 1);
    const daysInMonth = new Date(year, month, 0).getDate();
    const result = [];
    for (let i = 1; i <= daysInMonth; i++) {
      if ((year === maxYear && month === thisMonth && i <= today.getDate()) || year !== maxYear || (year === maxYear && month !== thisMonth)) {
        const value = numUtil.pad(i);
        result.push({text: value, value});
      }
    }
    dayOptions = result;
  }
</script>

<style lang="scss">
  .wrap :global(.wrap + .wrap) {
    margin-left: 16px;
  }
  :global(.s-color) {
    color: var(--T1) !important;
  }
</style>

<div class="wrap df">
  <Select class="f1 s-color" type="border" bind:value={year} options={yearOptions} placeholder={LG(lang.Year)} />
  <Select class="f1 s-color" type="border" bind:value={month} options={monthOptions} placeholder={LG(lang.Month)} />
  <Select class="f1 s-color" type="border" bind:value={day} options={dayOptions} placeholder={LG(lang.Day)} />
</div>
